import { useTranslation } from 'react-i18next';
import { API } from '@unboared/react';
import { QRCodeSVG } from 'qrcode.react';
import { MdVideogameAsset } from 'react-icons/md';

import { Logo } from '~/components/design/logo';
import { JoinButton } from '~/components/design/buttons/JoinButton';

import styles from './LeftSide.module.css';

// function OrDelimiter() {
//     return (
//         <div className={styles.orContainer}>
//             <div className={styles.orDelimiter} />
//             <p className={styles.orText}>OR</p>
//             <div className={styles.orDelimiter} />
//         </div>
//     );
// }

export function LeftSide() {
    const { t } = useTranslation();
    return (
        <div className={styles.container}>
            <div className={styles.logoContainer}>
                <Logo className={styles.logo} />
            </div>
            <div className={styles.qrSection}>
                <JoinButton onClick={() => window.open(API.getSessionLink())}>{t('console.join')}</JoinButton>
                <div className={styles.qrContainer}>
                    <QRCodeSVG className={styles.qrcode} value={API.getSessionLink()} />
                </div>
            </div>
            <div className={styles.joinContainer}>
                <div className={styles.joinTitleContainer}>
                    <MdVideogameAsset size={24} /> <p className={styles.joinTitle}>{t('console.instructions.title')}</p>
                </div>
                <p className={styles.joinText}>{t('console.instructions.1')}</p>
                <p className={styles.joinText}>{t('console.instructions.2')}</p>
                <p className={styles.joinText}>{t('console.instructions.3')}</p>
            </div>
            {/* <OrDelimiter />
            <div className={styles.connexion}>
                <p>Go on</p>
                <LinkButton
                    className={styles.joinUrl}
                    onClick={() => {
                        window.open(`${window.location.protocol}//${window.location.host}/gamepad`, '_blank');
                    }}
                >
                    {DEPLOY_URL}
                </LinkButton>
                <p>Enter the code below</p>
                <Button
                    textPreset="large"
                    className={styles.joinButtonCode}
                    onClick={() => {
                        window.open(API.getSessionLink(), '_blank');
                    }}
                >
                    {API.getSessionID()}
                </Button>
            </div> */}
        </div>
    );
}
